import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import List from '@mui/material/List';
import { IconButton } from '@mui/material';
import DrawerListItem from './DrawerListItem/DrawerListItem';
import styles from './Navigation.module.css';
import UserNavigation from './userNavigation/UserNavigation';

const routes = [
    {
        path: '/',
        text: 'Homepage',
    },
    {
        allowedRoles: ['admin'],
        path: '/user-configuration',
        text: 'User Configuration',
    },
    {
        allowedRoles: ['admin'],
        path: '/role-management',
        text: 'Role Management',
    },
    {
        path: '/password-change',
        text: 'Change Password',
    },
];

function MainNavigation({ user }) {
    const [drawerOpen, setDrawerOpen] = useState(false);

    const toggleDrawerOpenHandler = () => setDrawerOpen((state) => !state);

    const availableRoutes = routes.reduce((availableRoutes, { text, path, allowedRoles }) => {
        if (!checkIsAllowed(user, allowedRoles)) return availableRoutes;
        const routeItem = (
            <DrawerListItem key={text} listItemComponent={Link} listItemAttributes={{ to: path }} onClick={toggleDrawerOpenHandler} text={text} />
        );
        availableRoutes.push(routeItem);
        return availableRoutes;
    }, []);

    return (
        <div className={styles.wrapper}>
            <div className={styles.navigation}>
                <IconButton onClick={toggleDrawerOpenHandler}>
                    <MenuIcon sx={{ color: 'var(--color-white)' }} />
                </IconButton>
                <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawerOpenHandler}>
                    <List sx={{ paddingTop: 'var(--header__height--main)' }}>{availableRoutes}</List>
                </Drawer>
                <UserNavigation user={user} />
            </div>
        </div>
    );
}

export default MainNavigation;

function checkIsAllowed(user, allowedRoles) {
    if (!allowedRoles) return true;
    let allowedAccess = false;
    if (user) {
        allowedAccess = allowedRoles.reduce((allowedAccess, allowedRole) => {
            !allowedAccess && user.roles.includes(allowedRole) && (allowedAccess = true);
            return allowedAccess;
        }, false);
    }

    return allowedAccess;
}
